import './index.css';
import PropTypes from 'prop-types';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

const DEFAULT_COLORS = ['#10B2D0', '#095664', '#98D0DA'];

const PieChartCard = ({
  title,
  data,
  colorArray: customColorArray,
  arcLabelMode = 'value',
  showLegend = true,
}) => {
  const colorArray =
    customColorArray && customColorArray.length > 0
      ? customColorArray
      : DEFAULT_COLORS;

  const total = data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);
  const piechartData = [];
  for (let i = 0; i < data.length; i++) {
    piechartData.push({
      ...data[i],
      color: colorArray[i % colorArray.length],
    });
  }

  const getArcLabel = (item) => {
    if (arcLabelMode === 'percent') {
      if (!total) return '0%';
      return `${Math.round((item.value / total) * 100)}%`;
    }
    return `${item.value}`;
  };

  const hasData = data.length > 0 && total > 0;

  return (
    <div style={{ fontFamily: 'Sans-serif' }} className="card-large-body">
      {title ? <h2>{title}</h2> : null}
      <div className="pie-card-content">
        <div className="pie-card-chart">
          {!hasData ? (
            <div className="pie-card-empty">No data to display</div>
          ) : (
          <PieChart
            margin={10}
            hideLegend={true}
            width={320}
            height={260}
            slotProps={{
              legend: { hidden: true },
            }}
            series={[
              {
                highlightScope: { faded: 'series', highlighted: 'item' },
                faded: { innerRadius: 60, additionalRadius: -2 },
                arcLabel: getArcLabel,
                arcLabelMinAngle: 30,
                data: piechartData,
                innerRadius: 70,
                outerRadius: 100,
                paddingAngle: 5,
                cornerRadius: 5,
                startAngle: -180,
                endAngle: 180,
                cx: 150,
                cy: 130,
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fill: 'white',
                fontWeight: 'bold',
              },
              '& .MuiPieArc-root': {
                stroke: 'var(--white)',
                strokeWidth: 2,
              },
            }}
          />
          )}
        </div>

        {showLegend && hasData ? (
          <div className="pie-card-legend">
            {piechartData.map((item) => (
              <div key={item.id ?? item.label} className="pie-card-legend-item">
                <div
                  className="pie-card-legend-dot"
                  style={{ backgroundColor: item.color }}
                >
                </div>
                <div className="pie-card-legend-text">{item.label}</div>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};

PieChartCard.propTypes = {
  title: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
  colorArray: PropTypes.arrayOf(PropTypes.string),
  arcLabelMode: PropTypes.oneOf(['value', 'percent']),
  showLegend: PropTypes.bool,
};

export default PieChartCard;
